import { render, staticRenderFns } from "./Hotfix.vue?vue&type=template&id=3d2744b7&scoped=true&"
import script from "./Hotfix.vue?vue&type=script&lang=js&"
export * from "./Hotfix.vue?vue&type=script&lang=js&"
import style0 from "./Hotfix.vue?vue&type=style&index=0&id=3d2744b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2744b7",
  null
  
)

export default component.exports